import type { RuleDefinition } from '../domain/types';
import { getCellText } from '../domain/cells';
import { getFieldDefinition } from '../domain/fields';
import { parseNumeric } from '../utils/number';
import { NUMERIC_FIELDS, cellValueForParsing, finding, isFormulaWithoutResult } from './helpers';

export const BQ005: RuleDefinition = {
  id: 'BQ005',
  name: '数值格式错误',
  description: '检查工程量、综合单价和合价能否解析为有限数字。',
  defaultSeverity: 'error',
  enabled: true,
  applicableFields: NUMERIC_FIELDS,
  message: '数值无法解析。',
  suggestion: '请改为可识别的数字格式；支持千位分隔、前后空格、全角负号和括号负数。',
  check: ({ detailRows }) =>
    detailRows.flatMap((row) =>
      NUMERIC_FIELDS.flatMap((field) => {
        if (isFormulaWithoutResult(row, field)) return [];
        const parsed = parseNumeric(cellValueForParsing(row, field));
        if (parsed.ok) return [];
        const label = getFieldDefinition(field).label;
        return [
          finding(row, field, {
            currentValue: getCellText(row, field),
            message: `${label}无法解析为有效数字。`,
          }),
        ];
      }),
    ),
};
